import '../../styles/ContactUs.scss';
import { useEffect, useState } from "react";
import {ContactData} from "../types/Page";
import api from "../../api";
import PageHero from "./Components/PageHero";
import Header from "./Components/Header";
import hereToHelp from '../../assets/images/We Are Here To Help.svg';
import reachOut from '../../assets/images/Reach Out.svg';
import ContactFooter from "./Components/ContactFooter";

function ContactUs() {
    const [contactData, setContactData] = useState<ContactData | null>(null);

    async function fetchContactData() {
        try {
            const res = await api.get("/v1/contact");
            setContactData(res.data);

        } catch (error) {
            console.error(error);
        }
    }

    const [isOpen, setIsOpen] = useState(false);

    const checkOpeningStatus = () => {
        const now = new Date();

        // Convert to South African time
        const southAfricaTime = new Date(
            now.toLocaleString("en-US", {
                timeZone: "Africa/Johannesburg",
            })
        );

        const day = southAfricaTime.getDay();
        const hours = southAfricaTime.getHours();
        const minutes = southAfricaTime.getMinutes();

        const currentMinutes = hours * 60 + minutes;

        let openTime: number | null = null;
        let closeTime: number | null = null;

        // Monday - Friday
        if (day >= 1 && day <= 5) {
            openTime = 8 * 60;       // 08:00
            closeTime = 17 * 60;     // 17:00
        }

        // Saturday
        if (day === 6) {
            openTime = 9 * 60;       // 09:00
            closeTime = 13 * 60;     // 13:00
        }

        // Sunday stays closed
        if (openTime !== null && closeTime !== null) {
            setIsOpen(
                currentMinutes >= openTime &&
                currentMinutes < closeTime
            );
        } else {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        checkOpeningStatus();

        const interval = setInterval(() => {
            checkOpeningStatus();
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        fetchContactData();
    }, []);

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");

    return (
        <div>
            <Header />
            {contactData && contactData.page && contactData.page.headers && <PageHero headers={contactData.page.headers} page={contactData.page.slug}/>}

            <div className="contact-page-container">
                <div className="here-to-help">
                    <img src={hereToHelp} alt="We are here to help" />
                </div>
                <div className="contact-page-inner">
                    <div className="general-enquiries">
                        <h2>General Inquiries</h2>
                        <h1><a href="tel:+27218454001">+27 (0)21 845 4001</a></h1>
                        <a href="mailto:info@naturalvinegar.co.za" className="email-link">info@naturalvinegar.co.za</a>
                        <div className="divider" />
                        <div className="customer-care">
                            <h1>CUSTOMER CARE</h1>
                            <a href="mailto:customercare@naturalvinegar.co.za">customercare@naturalvinegar.co.za</a>
                        </div>
                    </div>
                    <div className="office-location">
                        <h2>Office Location</h2>
                        <h1><a href="https://maps.app.goo.gl/ft5zFL2ho7oJgrk29">Helderberg Industrial Park</a></h1>
                        <p>36 Chilwan Crescent, Helderberg Industrial Park, Western Cape 7140, South Africa</p>
                    </div>
                    <div className="operating-hours">
                        <h2>OPERATING HOURS</h2>
                        <div className="hours-inner">
                            <div className="day-item">
                                <div className="days">Monday – Friday</div>
                                <div className="hours">08:00 – 17:00</div>
                            </div>
                            <div className="day-item">
                                <div className="days">Saturday</div>
                                <div className="hours">09:00 – 13:00</div>
                            </div>
                            <div className="day-item">
                                <div className="days">Sunday</div>
                                <div className="hours">Closed</div>
                            </div>
                        </div>
                        <div className={`opening-status ${isOpen ? "open" : "closed"}`}>
                            <span className="status-dot"></span>
                            {isOpen ? "CURRENTLY OPEN" : "CURRENTLY CLOSED"}
                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-form">
                <div className="reach-out">
                    <img src={reachOut} alt="Reach Out" />
                </div>

                <div className="contact-form-inner">
                    <div className="get-in-touch">
                        <p className="title">CONTACT</p>
                        <h1>GET IN TOUCH</h1>
                        <div className="divider"/>
                        <p className="body">We’re here to help with every query — from product questions to trade partnerships. Reach out and our team will respond within one business day.</p>
                    </div>
                    <div className="form">
                        <input
                            type="text"
                            placeholder="Full Name"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                        /> <br />
                        <input
                            type="text"
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        /> <br />
                        <input
                            type="text"
                            placeholder="Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        /> <br />

                        <textarea
                            placeholder="Message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            />

                        <div className="send-message" onClick={() => {}} >Send Message</div>
                    </div>
                </div>
            </div>

            <div className="contact-map">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4283.5881047391085!2d18.877478675719367!3d-34.12055272313127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcdca359fadaaab%3A0x1b60fba56bd21638!2sSafari%20Vinegar!5e1!3m2!1sen!2sza!4v1789565049393!5m2!1sen!2sza"
                    // width="600"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                />
            </div>

            <ContactFooter />


        </div>
    )
}

export default ContactUs;
